import React from 'react';
import { TemplatePlaceholdersBlockProps } from './types';
import { Box, Button, TextField } from '@mui/material';
import styles from './TemplatePlaceholders.module.scss';
import { useTranslation } from 'react-i18next';
import TemplatePlaceholderRow from './TemplatePlaceholderRow';
import { v4 as uuidv4 } from 'uuid';

export const TemplatePlaceholdersBlock = ({
  templatePlaceholders,
  createTemplate,
  goBack,
  documentHTMLId,
  deletePlaceholder,
  addRow,
}: TemplatePlaceholdersBlockProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Box className={styles.container}>
        <Box
          display='flex'
          flexDirection='column'
          height='100%'
          className='inputs-editable'
          paddingTop='16px'
          paddingRight='16px'
        >
          <Box flexGrow='1' sx={{ maxHeight: '85%', paddingTop: '8px', overflow: 'auto' }}>
            <table style={{ width: '100%' }}>
              <tbody>
                {templatePlaceholders.map((el, index) => (
                  <TemplatePlaceholderRow
                    documentHTMLId={documentHTMLId}
                    index={index}
                    id={el.id}
                    data={el.data}
                    key={uuidv4()}
                    deletePlaceholder={deletePlaceholder}
                  />
                ))}
              </tbody>
            </table>
            {/*<Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
              <Button
                className='btn-default btn-action-basic'
                onClick={() => addRow()}
                style={{ marginLeft: '0.5rem' }}
                type='button'
                role='button'
                variant='contained'
                size='medium'
              >
                +
              </Button>
            </Box>*/}
          </Box>
          <Box
            display='flex'
            marginTop='auto'
            paddingTop='16px'
            gap='8px'
            justifyContent='flex-end'
          >
            <Button
              type='button'
              className='btn-default btn-action-basic btn-cancel'
              role='button'
              variant='contained'
              size='large'
              onClick={goBack}
            >
              {t('buttons.goBack')}
            </Button>
            <Button
              type='button'
              className='btn-default btn-action-basic'
              role='button'
              variant='contained'
              size='large'
              onClick={createTemplate}
            >
              {t('buttons.createTemplate')}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
